<template>
  <div v-if="clients">
    <b-field class="columns">
        <b-autocomplete
          class="column is-4"
          v-model="nomContact"
          type="search"
          placeholder="Rechercher par un contact..."
          :keep-first="keepFirst"
          :open-on-focus="openOnFocus"
          :data="dataContacts"
          @input="getAsyncContactData"
          :loading="isFetching"
          field="libelleRecherche"
          @select="selection">
          <template slot="empty">Aucun résultat trouvé, saisir au moins 3 caractères</template>
        </b-autocomplete>
    </b-field>
    <v-client-table class="fixed_header_client"
    :data="clientFiltre" :columns="columns" :options="options" name="listeClientProspect">
      <div slot="prospect" slot-scope="props">
        <b-icon icon="checkbox-marked-circle" class="is-small"
                type="is-primary" v-if="props.row.prospect"></b-icon>
      </div>
      <div slot="nomCommercial" slot-scope="props">
        <div class="is-flex is-justify-content-space-between is-align-items-start">
          <div class="level-left">
            {{props.row.nomCommercial}}
          </div>
          <div class="level-right is-flex">
            <niveau-blocage-icone
              v-if="props.row.blocageLevel"
              :niveau="props.row.blocageLevel"
              size="is-small"/>
          </div>
        </div>
      </div>
      <div slot="voir" slot-scope="props" style="cursor: pointer;">
        <router-link v-bind:to="{ name: 'ficheclient', params: {num: props.row.num}}">
          <b-icon icon="file-find" class="is-small" type="is-primary"/>
        </router-link>
      </div>
      <div slot="filter__prospect">
        <b-select v-model="filtreProspects">
          <option
              v-for="filtre in listeFiltres"
              :value="filtre"
              :key="filtre">
              {{ filtre }}
          </option>
        </b-select>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { Event } from 'vue-tables-2';
import { DEBOUNCE } from '@/configuration/autocompleteConf';
import { browseClientsByQuery } from '@/api/clients/index';
import { SET_CLIENTS } from '@/store/modules/clients-mutation-type';
import NiveauBlocageIcone from '@/components/general/NiveauBlocageIcone';


import { TEXTS, PER_PAGE_VALUE, RESULTS_PER_PAGE } from '@/configuration/clientTableConf';

const Clients = createNamespacedHelpers('clients');
const User = createNamespacedHelpers('user');

export default {
  name: 'liste',
  components: {
    niveauBlocageIcone: NiveauBlocageIcone,
  },
  data() {
    return {
      dataContacts: [],
      isFetching: false,
      nomContact: '',
      contactSelect: {},
      keepFirst: false,
      openOnFocus: false,
      trad: {
        NomCom: '↑↓ Nom Commercial',
        NomJuridique: '↑↓ Nom juridique',
        Prospect: '↑↓ Prospect',
        Adresse: '↑↓ Adresse',
        Ville: '↑↓ Ville',
        CodePostal: '↑↓ CP',
        Telephone: '↑↓ Téléphone',
        Email: '↑↓ Email',
        Secteur: '↑↓ Secteur',
        Voir: 'Voir',
      },
      listeFiltres: ['Tout', 'Clients', 'Prospects'],
      filtreProspects: '',
    };
  },
  computed: {
    ...Clients.mapGetters([
      'clients',
    ]),
    ...User.mapGetters({
      societeId: 'idSociete',
    }),
    columns() {
      return ['nomCommercial', 'nomJuridique', 'prospect', 'adressePostaleLibelle1', 'ville', 'codePostal', 'telephone', 'email', 'secteurActivite', 'voir'];
    },
    options() {
      return {
        headings: {
          nomCommercial: this.trad.NomCom,
          nomJuridique: this.trad.NomJuridique,
          prospect: this.trad.Prospect,
          adressePostaleLibelle1: this.trad.Adresse,
          codePostal: this.trad.CodePostal,
          ville: this.trad.Ville,
          telephone: this.trad.Telephone,
          email: this.trad.Email,
          secteurActivite: this.trad.Secteur,
          voir: this.trad.Voir,
        },
        sortable: ['nomCommercial', 'nomJuridique', 'prospect', 'adressePostaleLibelle1', 'ville', 'codePostal', 'telephone', 'email', 'secteurActivite'],
        filterByColumn: true,
        listColumns: {
          prospect: [{
            id: 0,
            text: 'Clients',
          },
          {
            id: 1,
            text: 'Prospects',
          },
          ],
        },
        filterable: ['nomCommercial', 'nomJuridique', 'adressePostaleLibelle1', 'ville', 'codePostal', 'email', 'secteurActivite'],
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          adressePostaleLibelle1: 'ellipsis colonneAdresseRechercheClient',
          ville: 'ellipsis colonneVilleRechercheClient',
          telephone: 'ellipsis colonneTelephoneRechercheClient',
          voir: 'colonneVoirClient has-text-centered',
          nomCommercial: 'colonneAdresseRechercheClient',
          nomJuridique: 'ellipsis colonneNomJuridiqueRechercheClient',
          codePostal: 'codePostalRechercheClient',
          prospect: 'colonneAvecPicto_Center',
          email: 'ellipsis colonneEmailRechercheClient',
        },
        customFilters: [{
          name: 'numFilter',
          callback(row, query) {
            return row.num === query;
          },
        }],
      };
    },
    clientFiltre() {
      if (this.filtreProspects === 'Prospects') return this.clients.filter(el => el.prospect);
      if (this.filtreProspects === 'Clients') return this.clients.filter(el => !el.prospect);
      return this.clients;
    },
  },
  methods: {
    ...Clients.mapMutations({
      setClients: SET_CLIENTS,
    }),
    ...Clients.mapActions({
      actionsPrechargementClients: 'prechargementClients',
    }),
    /* eslint-disable-next-line */
    getAsyncContactData: debounce(function () {
      this.dataContacts = [];
      if (this.nomContact.length <= 2) return;
      this.isFetching = true;
      browseClientsByQuery(this.nomContact).then((response) => {
        response.data.forEach((contact) => {
          this.dataContacts.push(contact);
        });
        this.isFetching = false;
      }).catch(() => {
        this.isFetching = false;
      });
    }, DEBOUNCE),
    selection(option) {
      if (option) {
        this.contactSelect = option;
        this.setClients(this.dataContacts);
        Event.$emit('vue-tables.filter::numFilter', this.contactSelect.cliNum);
        return;
      }
      // Si l'autocomplete est vide -> on libère le filtre
      if (!this.nomContact) {
        this.contactSelect = {};
        Event.$emit('vue-tables.filter::numFilter', null);
        const loadingComponent = this.$buefy.loading.open({ container: null });
        this.actionsPrechargementClients().then(() => {
          loadingComponent.close();
        }).catch((e) => {
          loadingComponent.close();
          throw e;
        });
      }
    },
  },
  mounted() {
    Event.$on('vue-tables.listeClientProspect.row-click', (data) => {
      this.$router.push({ name: 'ficheclient', params: { num: data.row.num } });
    });
  },
};
</script>




// WEBPACK FOOTER //
// src/components/clientProspect/recherche/liste.vue